










import Vue, { PropType } from 'vue'
import { getBookingPdf } from '~/api/RentalCar'
import IconButton from '~/components/IconButton.vue'
import { generateFile } from '~/utils/functions'
import { CarBooking } from '~/utils/interfaces/rentalCar'
export default Vue.extend({
  components: { IconButton },
  props: {
    item: { type: Object as PropType<CarBooking>, required: true },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async onClick() {
      try {
        this.loading = true
        const response = await getBookingPdf(this.item.uuid)
        generateFile(response, this.item.code + '.pdf')
      } finally {
        this.loading = false
      }
    },
  },
})
